export default __webpack_public_path__ + "assets/images/bb2c1aa860fea60db0bc5183090351a1.jpg";